"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  label: "Default (s)",
  value: "s"
}, {
  label: "Fixed one point (.1f)",
  value: ".1f"
}, {
  label: "Fixed two point (.2f)",
  value: ".2f"
}, {
  label: "Fixed three point (.3f)",
  value: ".3f"
}, {
  label: "Rounded percentage (.0%)",
  value: ".0%"
}, {
  label: "Grouped thousands with two significant digits",
  value: ",.2r"
}];
exports["default"] = _default;